import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// "Empresa activa" del super_admin (ver contexts/EmpresaContext.jsx). Vive en una
// variable de módulo — no en React — para que el interceptor la lea de forma síncrona
// en cada request sin re-suscribir cada página. Vacío/null = vista de plataforma
// (todas las empresas), que es el comportamiento histórico.
let _empresaActivaId = null;
export function setApiEmpresa(id) {
  _empresaActivaId = id || null;
}
export function getApiEmpresa() {
  return _empresaActivaId;
}

// Rutas que NUNCA se acotan por empresa: autenticación y el catálogo global de empresas.
const EMPRESA_SCOPE_EXCLUDE = [/^\/auth(\/|$)/, /^\/empresas(\?|$)/];

// Attach Bearer token from localStorage as fallback
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("chkr_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;

  // En los GET, inyecta ?empresa_id= con la empresa activa del super_admin para que
  // cada listado quede acotado a esa empresa sin tocar página por página. El backend
  // ignora el parámetro para cuentas que no son super_admin (ver auth.scope_empresa).
  const method = (config.method || "get").toLowerCase();
  const url = config.url || "";
  const excluida = EMPRESA_SCOPE_EXCLUDE.some((re) => re.test(url));
  if (_empresaActivaId && method === "get" && !excluida) {
    config.params = { empresa_id: _empresaActivaId, ...(config.params || {}) };
  }
  return config;
});

// El backend cierra la sesión de un dispositivo en cuanto el mismo usuario inicia sesión
// en otro (ver auth.py SESSION_REPLACED_DETAIL). Sin esto, el dispositivo desplazado solo
// vería errores 401 sueltos en cada acción sin entender por qué.
const SESSION_REPLACED_DETAIL = "Tu sesión se cerró porque iniciaste sesión en otro dispositivo.";
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && error.response?.data?.detail === SESSION_REPLACED_DETAIL) {
      localStorage.removeItem("chkr_token");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login?motivo=otra_sesion";
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Ocurrió un error. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
export { API };
